import React, { Component } from 'react';
import Translator from '../../../../requests/apa/Translator';
import Assets from '../../../../requests/apa/Asset';
import DeviceStorage from '../../../DeviceStorage/DeviceStorage';

class Page03 extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            imageError: false
        }
    }
    
    render() {
        const title = Translator.get('LandingPageClaroTv03_Titulo_TextoTitulo', "Nuevas funcionalidades para tu TV en vivo");

        const region = DeviceStorage.getItem("region");
        const defaultImage = Assets.get('LandingPageClaroTv03_Metadata02_Imagen', '')
        const image = Assets.get(`LandingPageClaroTv03_Metadata02_Imagen_${region}`, '') || defaultImage;

        return (
            <div className="landing-page_page page-03">
                <div className="content">
                    <h1>{title}</h1>
                    <img src={this.state.imageError ? defaultImage : image} 
                        onError={this.state.imageError ? () => {} : () => {
                            this.setState({imageError: true})
                        }}
                    />
                </div>
            </div>
    
        )
    } 
}

export default Page03;


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPageSTB/pages/03.jsx